
import { Network } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useHistoricalNodesData } from "@/hooks/useHistoricalNodesData";
import { NodesChart } from "./NodesChart";
import { NodeDifferenceIndicator } from "./NodeDifferenceIndicator";

interface ActiveNodesProps {
  value: number;
  isLoading: boolean;
}

export function ActiveNodes({ value, isLoading }: ActiveNodesProps) {
  // Fetch historical data
  const { 
    data: historicalData, 
    isLoading: isHistoricalLoading, 
    error 
  } = useHistoricalNodesData();

  if (isLoading) {
    return (
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Active Nodes</CardTitle>
          <Network className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">Loading...</div>
        </CardContent>
      </Card>
    );
  }

  // Calculate the difference between the last two daily values
  let difference = 0;
  if (historicalData?.lastTwoValues.length === 2) {
    const [latest, previous] = historicalData.lastTwoValues;
    if (latest?.total_addresses && previous?.total_addresses) {
      difference = Math.round(latest.total_addresses - previous.total_addresses);
    }
  }

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">Active Nodes</CardTitle>
        <Network className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        <div className="flex flex-col space-y-3">
          <div>
            <div className="flex items-center gap-2">
              <span className="text-2xl font-bold">
                {value.toLocaleString()}
              </span>
              <NodeDifferenceIndicator difference={difference} />
            </div>
            <div className="text-xs text-muted-foreground">
              Active nodes in the last 10 minutes with stake {'>'}999
            </div>
          </div>
          
          <div className="h-[120px] mt-4">
            <NodesChart 
              data={historicalData?.historicalData || []}
              isLoading={isHistoricalLoading}
              error={error}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
